export * from './full-layout.component';



// WEBPACK FOOTER //
// /home/jacobo/proyectos/venta-extranet/src/app/core/containers/full-layout/index.ts